/** Placeholder component for midarticlespecial adunit */
const AdMASPlaceholder = (): React.ReactElement => {
  return (
    <div
      data-testid="ad-midarticlespecial-placeholder"
      className="relative flex h-[250px] w-[300px] items-center justify-center border-gray-700 bg-gray-500 text-gray-700"
    >
      <span className="absolute top-1 text-5xs">ADVERTISEMENT</span>
      <span>MIDARTICLESPECIAL</span>
    </div>
  );
};

export default AdMASPlaceholder;
